<template>
    <b-modal
      v-if="currentAk != null"
      :visible="visible"
      @hidden="hide"       
      @change="change"
      scrollable
      ref="modal_line_details"
      id="modal-line-details"
      no-close-on-backdrop      
      :title="currentAk.type=='sw11kw'?$t('switch11k.title'):currentAk.type=='ak'?$t('ak.title'):$t('ak.title_ext')"
      :ok-only="true" 
      :ok-title="$t('close')" 
    >
        <!-- scheda descrittiva in alto -->
    <!-- | foto | Product | id | -->
    <b-row>
      <b-col cols="4" sm="4">
        <img v-if="currentAk.product_image" class="ml-4" :src="pathDeviceImages + currentAk.product_image"
          style="height:80px; width:auto; float: left; margin-right: 10px" />
        <img v-else :src="pathDeviceImages + '17230.jpg'" style="height:auto; width:80px;" />
      </b-col>
      <b-col cols="8" offset="1" offset-sm="0" sm="6">
        <b-row>
          <b-col>
            {{ $t("charger.prod_desc") }}
            <div><strong>{{currentAk.product_desc}}</strong></div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
   
    <!--SW 11kW - STATO -->
    <b-row v-if="this.currentAk.type=='sw11kw'">
        <b-col cols="12" offset-sm="1" sm="10"><strong>{{$t("charger.state")}}</strong>
        </b-col>
    </b-row>
    <b-row v-if="this.currentAk.type=='sw11kw'">
        <b-col cols="12" offset="1">{{currentAk.switch_state}}</b-col>
    </b-row>
    <div v-if="this.currentAk.type=='sw11kw'"><hr></div>

    <!--AK - Numero lampade e linee --> 
    <div v-if="this.currentAk.type=='ak' || this.currentAk.type=='akext'">
      <b-row>
        <b-col cols="6" offset="1">{{ $t("ak.num_lines") }}</b-col>
        <b-col cols="5" >{{currentAk.num_line}}</b-col>
      </b-row>
      <b-row>
        <b-col cols="6" offset="1">{{ $t("ak.num_line_error") }}</b-col>
        <b-col cols="5" >{{currentAk.num_line_error}}</b-col>
      </b-row>
      <!-- <b-row>
        <b-col cols="6" offset="1">{{ $t("ak.num_line_fuse_error") }}</b-col>
        <b-col cols="5" >{{currentAk.num_line_fuse_error}}</b-col>
      </b-row>
      <b-row>
        <b-col cols="6" offset="1">{{ $t("ak.num_line_isolation_error") }}</b-col>
        <b-col cols="5" >{{currentAk.num_line_isolation_error}}</b-col>
      </b-row>
      <b-row>
        <b-col cols="6" offset="1">{{ $t("ak.num_line_overcurrent") }}</b-col>
        <b-col cols="5" >{{currentAk.num_line_overcurrent}}</b-col>
      </b-row> -->
      <b-row>
        <b-col cols="6" offset="1">{{ $t("ak.num_lamp_found") }}</b-col>
        <b-col cols="5" >{{currentAk.num_lamp_found}}</b-col>
      </b-row>
      <b-row>
        <b-col cols="6" offset="1">{{ $t("ak.num_lamp_error") }}</b-col>
        <b-col cols="5" >{{currentAk.num_lamp_error}}</b-col>
      </b-row>
      <hr>
    </div>  

    
    <!-- Errori rilevati -->
    <b-row>
      <b-col cols="12" offset-sm="1" sm="10"><strong>{{ $t("details_cu_modal.cu_error") }}</strong></b-col>
    </b-row>
    <div v-if="this.currentAk.type=='ak' || this.currentAk.type=='akext'">
      <b-row  v-if='currentAk.error_com_cpu_ak=="ON"'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("ak.error_com")}}</b-col></b-row>
      <b-row  v-if='currentAk.num_line_error>0'><b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i>{{$t("ak.error_lines")}}</b-col></b-row>
      <b-row  v-if='currentAk.num_line_error==0 && currentAk.error_com_cpu_ak=="OFF"'>
        <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("details_cu_modal.cu_no_error")}}</b-col>
      </b-row>
      <b-row v-else-if='currentAk.num_line_error==0 && currentAk.error_com_cpu_akext=="OFF"'>
        <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("details_cu_modal.cu_no_error")}}</b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row v-if='currentAk.error_com_cpu_switch11kw == "ON"'><b-col offset-sm="1" sm="10"><i class="fa fa-exclamation-circle mr-2" style="color:red"></i></b-col></b-row>
      <b-row v-if="currentAk.error_com_cpu_switch11kw == 'OFF'">
        <b-col cols="12" offset-sm="1" sm="10"><i class="fa fa-check mr-2" style="color:green"></i>{{$t("details_cu_modal.cu_no_error")}}</b-col>
      </b-row>
    </div>
    <hr>

 
    <!-- Details -->
    <b-row>
        <b-col cols="12" offset-sm="1" sm="10"><strong>{{ $t("details_lamp.lamp_details") }}</strong>
        </b-col>
    </b-row>
    <b-row v-if="currentAk.product_code!=null && currentAk.product_code!=''">
      <b-col cols="6" offset="1">{{ $t("details_lamp.lamp_code") }}</b-col>
      <b-col cols="5" >{{currentAk.product_code}}</b-col>
    </b-row>
    <b-row v-if="currentAk.order_code!=null && currentAk.order_code!=''">
      <b-col cols="6" offset="1">{{ $t("details_lamp.lamp_order_code") }}</b-col>
      <b-col cols="5" >{{currentAk.order_code}}</b-col>
    </b-row>
    <b-row>
      <b-col cols="6" offset="1">Serial ID</b-col>
      <b-col cols="5" >{{currentAk.serial_ID.toUpperCase()}}</b-col>
    </b-row>
    <b-row v-if="currentAk.type != 'sw11kw'">
      <b-col cols="6" offset="1">{{ $t("ak.i_out") }}</b-col>
      <b-col cols="5" >{{currentAk.i_out}}mA</b-col>
    </b-row>

    </b-modal>
</template>

<script>
// import Vue from 'vue'

export default {
  name: "AkDetails",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    currentAk: null,
    scanning: false,
    visible: {
      type: Boolean,
      default: false
    },
  },

  emits:['hide', 'change'],

  data() {
    return {
        pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
        pathDevicePdf: process.env.VUE_APP_PATH_DEVICE_PDF,                       //pathDevicePdf for DEV : "https://d1y7ruw82jsjj9.cloudfront.net/",
        isVisible: false, //*
    };
  },

  computed: {

  },

  mounted() {
    console.log("mounted", this.currentAk);
  },

  methods: {
 
    //cerca nelle properties dell'oggetto disp, isola quelle che contengono 'error' e verifica se il valore è ON
    NessunErrore(disp) {
        let noerrore = true
        for (const property in disp)
        {
            if ((property.includes("error")) && (disp[property] === "ON"))
            {
                noerrore = false;
            }
        }
        return noerrore;     
    },

    //si attiva con l'evento 'change' ed emette verso il padre un evento 'change'
    change(visible) {
        // console.log("MASSI01: change visible", visible)
        this.$emit("change", visible);
    },
    //si attiva con l'evento 'hide' ed emette verso il padre un evento 'hide'
    hide() {
        // console.log("MASSI02: emesso hide")
         this.$emit("hide");
    },

  }
}
</script>

<style>
</style>